import React, { Component } from 'react';

import './LocateButton.css'

import imgLocate from './.image/locate.png'
export class LocateButton extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className='locateButton' 
            style={{ 
                width: this.props.width ? this.props.width : '35px', 
                height: this.props.height ? this.props.height : '35px',
                lineHeight: `${this.props.height ? this.props.height-8 : 35}px`
            }}
            onClick={this.props.onClick}>
                <img src={imgLocate} width={this.props.width} height={this.props.height} alt="定位"/>
            </div>
        );
    }
}